import React from 'react';
import { Server } from '../../server/server';
import { getBannerImage, getPortraitImage } from '../util/user';
import { BsCalendarWeek, BsChatDotsFill, BsFillEyeFill, BsFillEyeSlashFill, BsFillPersonPlusFill, BsPencilFill } from 'react-icons/bs';
import MessageModal from '../modals/MessageModal';
import AlertModal from '../modals/AlertModal';
import { NavLink, Navigate } from 'react-router-dom';
import QuestionModal from '../modals/QuestionModal';
import EditProfileModal from '../modals/EditProfileModal';
import BlogCard from '../elements/BlogCard';
import { WithRouterProps } from '../util/withRouter';
import ContentPanel from '../elements/ContentPanel';
import ActivityButtons from '../elements/ActivityButtons';
import PageEnvelope from '../elements/PageEnvelope';
import './SitePage.css'

interface ProfilePageProps {
  router: WithRouterProps;
}

interface ProfilePageState {
  profile: any;
  profileError: string;
  followers: any[];
  following: any[];
  message: string;
  alert: string;
  question: string;
  navigate: string;
  openEditProfile: boolean;
  blogs: any[];
  posts: any[];
  loading: boolean;
  loadingMore: boolean;
  filter: string;
  maxPosts: number;
  hideMore: boolean;
}

class ProfilePage extends React.Component<ProfilePageProps, ProfilePageState> {
  author = '';
  posLodMore = 0;
  isActivity = true;

  constructor(props: ProfilePageProps) {
    super(props);

    this.state = {
      profile: null,
      profileError: '',
      followers: [],
      following: [],
      message: '',
      alert: '',
      question: '',
      navigate: '',
      openEditProfile: false,
      blogs: [],
      posts: [],
      loading: false,
      loadingMore: false,
      filter: 'activity',
      maxPosts: 10,
      hideMore: false
    };

    this.onFriendUpdated = this.onFriendUpdated.bind(this);
    this.onSendMessage = this.onSendMessage.bind(this);
    this.onQuestionYes = this.onQuestionYes.bind(this);
    this.onQuestionNo = this.onQuestionNo.bind(this);
    this.openEditProfile = this.openEditProfile.bind(this);
    this.onCloseEditProfile = this.onCloseEditProfile.bind(this);
    this.onBlogClick = this.onBlogClick.bind(this);
    this.onBlogEdit = this.onBlogEdit.bind(this);
    this.onActivityUpdated = this.onActivityUpdated.bind(this);
  }

  componentDidMount() {
    let filter = sessionStorage.getItem('profile-filter');
    this.isActivity = filter ? JSON.parse(filter) : true;

    this.loadProfile();
    Server.user.addEventListener('friend-updated', this.onFriendUpdated);
    Server.activity.addEventListener('activity-updated', this.onActivityUpdated);
  }
    
  componentDidUpdate(prevProps: Readonly<ProfilePageProps>) {
    if(prevProps.router.location.pathname != this.props.router.location.pathname) 
      this.loadProfile();
  }
  
  componentWillUnmount() {
    Server.user.removeEventListener('friend-updated', this.onFriendUpdated);
    Server.activity.removeEventListener('activity-updated', this.onActivityUpdated);
  }

  async getBlogs(params: any) {
    if (this.state.blogs.length == 0)
      this.setState({loading: true});

    let response = await Server.blogs.getBlogs(params);
    if (!response.success)
      return

    let blogs = response.blogs;
    if (this.state.loadingMore)
      blogs = this.state.blogs.concat(blogs);

    this.setState({blogs: blogs, loading: false, loadingMore: false});

    setTimeout(() => {
      let div = document.getElementById('id-app-page');
      div.scrollTo(0, this.posLodMore);
    }, 10);
  }

  onBlogClick(blog:any) {
    // this.saveState();
    this.setState({navigate: '/blog/' + blog.slug})
  }

  onBlogEdit(blog:any) {
    // this.saveState();
    this.setState({navigate: '/blog/edit/' + blog.slug})
  }

  async loadPosts(author:string) {
    let cachedPosts = await Server.activity.getPostsCache();
   
    if(!cachedPosts) {
      let params:any = {limit: 10};
      let response = await Server.activity.getPosts(params);
      if(response.success) {
        cachedPosts = response.posts;
        await Server.activity.setPostsCache(cachedPosts, false);
        window.sessionStorage.setItem(`ActivityPostsRefresh`, new Date().getTime().toString());
      }
    }

    let posts = [];
    for (let i = 0; i < cachedPosts.length; i++) 
      if(cachedPosts[i].author == author)
        posts.push(cachedPosts[i]);

    if(posts.length > this.state.maxPosts)
      posts = posts.slice(0, this.state.maxPosts);

    await Server.public.loadProfiles([author]);

    this.setState({ posts });
  }

  async loadMorePosts() {
    let maxPosts = this.state.maxPosts + 10;
    this.setState({maxPosts});

    this.setState({ loadingMore: true })

    let posts = await Server.activity.getPostsCache();

    if(posts.length >= maxPosts) {
      setTimeout(() => {
        this.loadPosts(this.state.profile.id);
        this.setState({ loadingMore: false })
      }, 250);
      return;
    }

    // let morePosts = await Server.activity.getMorePosts();
    
    // if(morePosts) {
    //   await this.loadPosts(this.state.profile.id);
    //   this.setState({ loadingMore: false })
    // }
    // else
    //   setTimeout(() => {
    //     this.setState({ loadingMore: false, hideMore: true });
    //   }, 250);
  }

  onActivityUpdated() {
    if(this.state.posts.length == 0)
      this.loadPosts(this.state.profile.id);
  }

  onFriendUpdated(event:any) {
    this.forceUpdate();
  }

  async loadProfile() {
    let profile = Server.public.getProfile(Server.user.getId());

    if(this.props.router.params.id) {
      let slug = this.props.router.params.id;

      let checkProfile = Server.public.getProfileFromSlug(slug);
      if(checkProfile && Server.account.isLoggedIn() && Server.user.isFriend(checkProfile.id)) {
        this.setState({profile: checkProfile});
        await Server.public.removeProfileFromCache(checkProfile.id);
      }

      let response = await Server.public.loadProfileFromSlug(slug);
      if(response.success) 
        profile = response.profile;
      else {
        this.setState({profile: null, profileError: response.message});
        return;
      }
    }

    if(this.state.filter == 'activity')
      this.loadPosts(profile.id);
    else
      this.getBlogs({author: profile.id});

    this.setState({profile, maxPosts: 10});
  }

  onSendMessage() {
    let chats = Server.user.getChats();
    let chat = chats.find((c:any) => c.user == this.state.profile.id);

    if(chat) {
      this.setState({navigate: `/chat/${this.state.profile.slug}`});
      return;
    }

    this.setState({message: 'Starting chat...'});

    setTimeout(async () => {
      let response = await Server.chat.startChat({
        type: 'direct',
        members: [this.state.profile.id]
      });

      if(response.success) {
        Server.user.startChat({id: response.id, type: 'direct', user: this.state.profile.id});
        Server.network.sendCommand('start-chat', {chat: response.id, type: 'direct', user: this.state.profile.id});
        this.setState({navigate: `/chat/${this.state.profile.slug}`});
      }
      else 
        this.setState({alert: response.message, message: ''})
    }, 500);
  }

  async onFollow() {
    if(!Server.account.isLoggedIn()) {
      this.setState({alert: 'Please login to follow this users activity.'});
      return;
    }

    let isFollowing = Server.user.isFollowing(this.state.profile.id);
    let response:any = null;
    if (isFollowing) {
      this.setState({ message: 'Unfollowing...' });
      response = await Server.user.unfollow(this.state.profile.id);
    }
    else {
      this.setState({ message: 'Following...' });
      response = await Server.user.follow(this.state.profile.id);
    }

    setTimeout(() => {
    
      if (response.success) {
        this.setState({message: ''});
      }
      else 
        this.setState({message: ''});
    }, 500);
  }

  async onInvite() {
    if(!Server.account.isLoggedIn()) {
      this.setState({alert: 'Please login to invite this user to be your friend.'});
      return;
    }

    let friend = Server.user.getFriend(this.state.profile.id);
    if(!friend)
      this.setState({question: `Invite ${this.state.profile.name} to be your friend?`});
    else
      this.setState({alert: `You have already sent ${this.state.profile.name} an invite.`})
  }

  onQuestionYes() {
    this.setState({question: '', message: 'Sending invite...'});
    setTimeout(async () => {
      await Server.user.inviteFriendBySlug(this.state.profile.slug);
      this.setState({message: '', alert: `Invite sent!`});
    }, 500);
  }

  onQuestionNo() {
    this.setState({question: ''});
  }

  openEditProfile() {
    this.setState({openEditProfile: true});
  }

  async onCloseEditProfile() {
    let profile = Server.user.getProfile();
    Server.public.addProfileToCache(profile);
    this.setState({profile, openEditProfile: false});
  }

  renderActionButtons() {
    if(this.state.profile.slug == Server.user.getSlug()) {
      return (
        <div className="site-page-row" style={{justifyContent: 'right'}}>
          <button onClick={this.openEditProfile} className="site-page-icon-button">
            <BsPencilFill />
          </button>
        </div>      
      )
    }

    let isFriend = Server.account.isLoggedIn() && Server.user.isFriend(this.state.profile.id);
    let isFollowing = Server.account.isLoggedIn() && Server.user.isFollowing(this.state.profile.id);

    return (
      <div className="site-page-row" style={{justifyContent: 'right'}}>
        {isFriend &&
          <button className="site-page-icon-button" onClick={this.onSendMessage}><BsChatDotsFill size="1.2em"/></button>
        }

        {!isFriend &&   
          <button className="site-page-icon-button" onClick={() => this.onInvite()}><BsFillPersonPlusFill size="1.2em"/></button>
        }

        {!isFriend && !isFollowing &&  
          <button className="site-page-icon-button" onClick={() => this.onFollow()}><BsFillEyeFill size="1.2em"/></button>
        }

        {!isFriend && isFollowing && 
          <button className="site-page-icon-button" onClick={() => this.onFollow()}><BsFillEyeSlashFill size="1.2em"/></button>
        }
      </div>
    )
  }

  onFilter(filter: string) {
    this.posLodMore = 0;

    this.setState({filter});

    // sessionStorage.setItem('profile-filter', this.isActivity.toString());

    if (filter == 'activity') {
      this.setState({posts: []});
      setTimeout(() => {
        this.loadPosts(this.state.profile.id);
      }, 10);
    }
    else {
      this.setState({blogs: []});
      setTimeout(() => {
        this.getBlogs({author: this.state.profile.id});
      }, 10);
    }
  }

  onLoadMore() {
    if(!Server.account.isLoggedIn()) {
      this.setState({alert: 'Please login to view more community activity.'});
      return;
    }

    if (this.isActivity) {
      this.loadMorePosts();
      return;
    }

    let data  = this.isActivity ? this.state.posts : this.state.blogs;
    let index = data.length - 1;
    let id    = data[index].id;
    let date  = data[index].date;

    let params = {
      author: this.state.profile.id,
      before: {date, id}
    }

    this.getBlogs(params);

    let div = document.getElementById('id-app-page');
    this.posLodMore = div.scrollTop;
    this.setState({ loadingMore: true })
  }

  renderLoadMoreButton() {
    return (
      <div style={{marginTop: '5px'}}>
        <button 
          onClick={()=>this.onLoadMore()} 
          disabled={this.state.loadingMore ? true : false}
        >
          {this.state.loadingMore ? 'Loading...' : 'Load More'}
        </button>
      </div>
    )
  }

  onPostClick(id:string) {
    this.setState({navigate: "/activity/post/" + id});    
  }

  renderPosts() {
    if (this.state.loading)
      return (<div className="site-page-panel">Loading...</div>);

    let divs = [];
    for (let i = 0; i < this.state.posts.length; i++) {
      let post = this.state.posts[i];
      let repost = null;
      if(post.repost) {
        repost = post.author;
        post = post.repost;
      }

      divs.push(
        <ContentPanel 
          key={i}
          author={post.author}
          date={post.date}
          content={post.content}
          reply={true}
          repost={repost}
          onClick={()=>this.onPostClick(post.id)}
        >
          <ActivityButtons 
            likes={post.likes} 
            liked={post.liked} 
            post={post} 
            reply={true} 
          />
        </ContentPanel>
      )
    }

    let message = 'No posts yet.';
    let oldestDate = Server.activity.getOldestPostDate();
    if(oldestDate) 
      message = `No posts since ${oldestDate.toLocaleString()}.`;

    return divs.length > 0 ? divs : <div className="site-page-panel">{message}</div>
  }

  renderBlogs() {
    if (this.state.loading)
      return (<div className="site-page-panel">Loading...</div>);

    let divs = [];
    for (let i = 0; i < this.state.blogs.length; i++)
      if(this.state.blogs[i].state == 'published')
        divs.push(<BlogCard key={i} data={this.state.blogs[i]}  onClick={this.onBlogClick} onEdit={this.onBlogEdit} />);

    return divs.length > 0 ? divs : <div className="site-page-panel">No blogs yet.</div>
  }

  render() {
    let parts = window.location.pathname.split('/');
    if(parts.length == 2 && !Server.account.isLoggedIn())
      return(<Navigate replace to="/" />);

    if(this.state.navigate != '') 
      return <Navigate to={this.state.navigate} />;

    if (this.state.profile == null) {
      return (
        <div className="site-page">
          <PageEnvelope width="600px">
            <div className="site-page-panel">
              {this.state.profileError == '' ?
                <div>Loading...</div> :
                <div>{this.state.profileError}</div>
              }
            </div>
          </PageEnvelope>
        </div>
      )
    }
      
    let joined = new Date(this.state.profile.joined).toLocaleDateString();
    let isFriend    = Server.account.isLoggedIn() && Server.user.isFriend(this.state.profile.id);
    let isCurrent   = Server.account.isLoggedIn() && Server.user.isCurrent(this.state.profile.id);
    
    return (
      <div className="site-page">
        <PageEnvelope width="600px">
          <div className="site-page-column">

            <div className="site-page-column" style={{rowGap: '0px'}}>
              <div className="site-page-row" style={{position: 'relative'}}>
                <img className="site-portrait-banner" src={getBannerImage(this.state.profile)} />
                <img 
                  className="site-page-portrait" 
                  style={{
                    position: 'absolute', 
                    bottom: '0px', 
                    left: '10px',
                    transform: 'translateY(45%)',
                    width: '80px',
                    height: '80px'
                  }} 
                  src={getPortraitImage(this.state.profile)} 
                />
              </div>

              <div className="site-page-panel" style={{padding: '15px', borderTopLeftRadius: '0px', borderTopRightRadius: '0px'}}>
                <div style={{marginTop: '-5px', marginRight: '-5px'}}>
                  {this.renderActionButtons()}
                </div>

                <div className="site-page-row" style={{alignItems: 'normal', marginTop: '-10px'}}>
                  <div className="site-page-title-text">{this.state.profile.name}</div>
                  <div className="site-page-subtext">@{this.state.profile.slug}</div>
                </div>

                {this.state.profile.bio && 
                  <div>{this.state.profile.bio}</div>
                }

                <div className="site-page-row" style={{marginTop: '5px'}}>
                  <BsCalendarWeek />
                  <div className="site-page-subtext">Joined {joined}</div>
                </div>


                {(isCurrent || isFriend) && 
                  <div className="site-page-row site-page-subtext" style={{marginTop: '5px', columnGap: '15px'}}>
                    <NavLink to={`/profile/${this.state.profile.slug}/followers`}>
                      {this.state.profile.followers.length} Followers
                    </NavLink>
                    <NavLink to={`/profile/${this.state.profile.slug}/following`}>
                    {this.state.profile.following.length} Following
                    </NavLink>
                  </div>
                }
              </div>
            </div>

            <div className="site-page-column" style={{marginTop: '10px'}}>
              <div>
                <select
                  id="ProfileFilterSelect"
                  style={{width: '200px'}} 
                  value={this.state.filter} 
                  onChange={(e)=>this.onFilter(e.currentTarget.value)}
                >
                  <option value="activity">Activity Posts</option>
                  <option value="blogs">Published Blogs</option>
                </select>
              </div>

              {this.state.filter == 'activity' ? this.renderPosts() : this.renderBlogs()}

              {!this.state.loading && !this.state.hideMore && this.state.filter == 'activity'
                ? this.renderLoadMoreButton()
                : this.state.blogs.length > 0 && this.renderLoadMoreButton()
              }
            </div>

          </div>
        </PageEnvelope>

        <EditProfileModal open={this.state.openEditProfile} onClose={this.onCloseEditProfile} />
        <MessageModal message={this.state.message} />
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
        <QuestionModal message={this.state.question} onYes={this.onQuestionYes} onNo={this.onQuestionNo} />
      </div>
    );
  }
}

export default ProfilePage;
